/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.687.2946c.207-.0376.419-.0376.626 0l10.4106 1.8929A1.25 1.25 0 0 1 23.75 3.4173V4.5c0 .6904-.5596 1.25-1.25 1.25h-21C.8096 5.75.25 5.1904.25 4.5V3.4173a1.25 1.25 0 0 1 1.0264-1.2298L11.687.2946Zm.3577 1.4759a.2496.2496 0 0 0-.0894 0L1.75 3.626v.624h20.5v-.624L12.0447 1.7705ZM.25 20.5c0-.6903.5596-1.25 1.25-1.25h21c.6904 0 1.25.5597 1.25 1.25v2c0 .6904-.5596 1.25-1.25 1.25h-21c-.6904 0-1.25-.5596-1.25-1.25v-2Zm1.5.25v1.5h20.5v-1.5H1.75ZM10.9092 17H9.1274l-.7116-1.9519H4.4934L3.7697 17H2l3.3387-9h2.2197l3.3508 9ZM6.4455 9.6883l-1.3927 3.8034h2.7914L6.4455 9.6883ZM11.7484 8h4.0867l-.0122.0063c.9062 0 1.6359.32 2.1954.9603.5595.6401.8392 1.3619.8392 2.1652 0 .8222-.2797 1.5502-.8392 2.1778-.5595.6277-1.3136.9415-2.2562.9415h-2.317V17h-1.6967V8Zm1.6846 4.6883h2.2622l-.0121-.0125c.4439 0 .8027-.1569 1.0825-.4645.2797-.3075.4196-.6653.4196-1.0732 0-.408-.1338-.7657-.4014-1.0732-.2676-.3075-.6021-.4645-1.0095-.4645H13.433v3.0879Z"
      clipRule="evenodd"
    />
    <path fill="currentColor" d="M20.2668 17H22V8h-1.7332v9Z" />
  </React.Fragment>,
  'MenuAPIGovernance'
);
